__turbopack_context__.v({
  "buttonContainer": "styles-module__xLOIrW__buttonContainer",
  "cardContent": "styles-module__xLOIrW__cardContent",
  "cardImage": "styles-module__xLOIrW__cardImage",
  "cardSubtitle": "styles-module__xLOIrW__cardSubtitle",
  "cardTitle": "styles-module__xLOIrW__cardTitle",
  "caseCard": "styles-module__xLOIrW__caseCard",
  "casesGrid": "styles-module__xLOIrW__casesGrid",
  "casesSection": "styles-module__xLOIrW__casesSection",
  "hidden": "styles-module__xLOIrW__hidden",
  "image": "styles-module__xLOIrW__image",
  "viewMoreButton": "styles-module__xLOIrW__viewMoreButton",
  "visible": "styles-module__xLOIrW__visible",
});
